import { OptionsProps } from './form';
import { SelectProps, FormControl, InputLabel, FormHelperText, Select, MenuItem } from '@mui/material';
import { Field, FieldProps, getIn } from 'formik';
import { isEmpty } from 'lodash';

interface FormSelectProps extends SelectProps {
  options?: OptionsProps[];
}

function FormSelect({ name, label, options, margin, size = 'small', required, ...rest }: FormSelectProps) {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const { touched, errors } = form;
        const errorText = getIn(touched, field.name) && getIn(errors, field.name);
        const isError = Boolean(errorText);

        /**
         * @fieldLabelProps {fieldLabelProps} label is Empty add hiddenLabel
         */
        const fieldLabelProps = isEmpty(label) ? {} : { label };

        return (
          <FormControl hiddenLabel={isEmpty(label)} margin={margin ?? 'normal'} size={size} fullWidth>
            <InputLabel required={required}>{label}</InputLabel>
            <Select error={isError} {...fieldLabelProps} {...rest} {...field}>
              {Array.isArray(options) &&
                options.map(({ value: val, label: lab }) => (
                  <MenuItem key={val} value={val}>
                    {lab}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText error={isError}>{errorText}</FormHelperText>
          </FormControl>
        );
      }}
    </Field>
  );
}

export default FormSelect;
